import api from "@/libs/axios";
import * as ep from "./endpoints";

export default {
  namespaced: true,
  state: () => ({
    loading: false,
    aboutMinistry: {},
  }),
  getters: {
    aboutMinistry(state) {
      return state.aboutMinistry;
    },
    loading(state) {
      return state.loading;
    },
  },
  mutations: {},
  actions: {
    async getAboutMinistry(context) {
      context.state.loading = true;
      api.get(ep.about_ministry).then((res) => {
        context.state.aboutMinistry = res.data.data;
        context.state.loading = false;
      });
    },
  },
};
